<template>
  <div id="history_window_content">
    <ul
      ref="listview"
      class="ImperiaHistory i-history-entries"
      style="max-height: 300px; overflow: auto; position: relative"
    >
      <li
        class="clearfix"
        v-for='(item, idx) in items'
        :key='idx'>
        <span class="history_date i-col-sm-3">{{ item.label }}</span>
        <div class="history_entry i-col-sm-9">
          <span>{{ item.user }}</span><br />
          <span>{{ item.text }}<br /></span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { showToast } from '@/utils/tools';

import fetchService from '@/utils/model/fetch_service';

export default defineComponent({
  props: ['nodeId'],
  data: () => ({
    items: Array,
    pagination: {
      __imperia_node_id: '',
      page: 0,
      page_size: 20,
    },
    finalPage: false,
    pageLoading: false,
  }),
  async created() {
    this.pagination.__imperia_node_id = this.nodeId;
    const response = await fetchService.GetData('docbrowser_history', this.pagination);

    if (response.error) {
      showToast(response.message, response.error);
      this.$emit('update:show', false);
    } else {
      this.items = response.data;

      const { listview } = this.$refs;

      listview.addEventListener('scroll', this.scrollEvent);
    }
  },
  computed: {
    ...mapState(['LANG']),
  },
  methods: {
    async fetchPage() {
      const response = await fetchService.GetData('docbrowser_history', this.pagination);

      if (response.data.length < this.pagination.page_size) {
        this.finalPage = true;

        const { listview } = this.$refs;

        listview.removeEventListener('scroll', this.scrollEvent);

        return;
      }
      this.items = [...this.items, ...response.data];
      this.pageLoading = false;
    },
    scrollEvent(event) {
      if (this.finalPage || this.pageLoading) return;

      const listview = event.target;
      const margin = 200;

      if (listview.scrollTop + listview.offsetHeight + margin > listview.scrollHeight) {
        this.pageLoading = true;
        this.pagination.page += 1;
        this.fetchPage();
      }
    },
  },
});
</script>

<style scoped lang='scss'>
</style>
